import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { LINE_STYLE } from "~/styles/line-style";

export const ButtonItem = styled.button`
  width: calc(100% - 16px);
  padding-right: 8px;
  display: flex;
`;

export const SpanText = styled.span`
  color: ${COLOR.GRAY900.code};
  ${LINE_STYLE(1)}
`;

export const SpanGravureText = styled.span`
  color: ${COLOR.GRAY500.code};
  flex-shrink: 0;
`;
